import {
  Swiper,
  Navigation,
  Pagination,
  Autoplay,
} from 'swiper';

Swiper.use([
  Navigation,
  Pagination,
  Autoplay,
]);

const snbSliderInit = (item) => {
  const sliderItem = item.querySelector('.snb-slider__slide');
  const sliderTime = sliderItem.getAttribute('data-time');
  const sliderTimeHourText = sliderTime.split(':')[0];
  const sliderTimeHour = parseInt(sliderTimeHourText, 10);
  const sliderDayNightText = document.querySelector('.snb-slider__day_night');

  const sliderDayNightBG = document.querySelector('.snb-slider__data');
  if (sliderTimeHour > 5 && sliderTimeHour < 22) {
    sliderDayNightText.innerHTML = 'dag';
    sliderDayNightBG.classList.add('background-brightSun');
  } else {
    sliderDayNightText.innerHTML = 'nacht';
    sliderDayNightBG.classList.add('background-easternBlue');
  }

  const swiperItem = new Swiper(item, {
    navigation: {
      nextEl: item.querySelector('.slider__button--next') as HTMLElement,
      prevEl: item.querySelector('.slider__button--prev') as HTMLElement,
      disabledClass: 'slider__button--disabled',
    },
    on: {
      slideChange() {
        const indexCurrentSlide = swiperItem.realIndex;
        const currentSlide = swiperItem.slides[indexCurrentSlide];
        const sliderTimeSlide = currentSlide.getAttribute('data-time');
        const dayOverule = currentSlide.getAttribute('day');
        const sliderTimeHourTextSlide = sliderTimeSlide.split(':')[0];
        const sliderTimeHourSlide = parseInt(sliderTimeHourTextSlide, 10);
        const sliderTimeText = document.querySelector('.snb-slider__time');

        const sliderDayNightBGSlide = document.querySelector('.snb-slider__data');
        if (sliderTimeHourSlide > 5 && sliderTimeHourSlide < 22) {
          sliderDayNightText.innerHTML = 'dag';
          sliderDayNightBGSlide.classList.remove('background-easternBlue');

          sliderDayNightBGSlide.classList.add('background-brightSun');
        } else {
          sliderDayNightText.innerHTML = 'nacht';
          sliderDayNightBGSlide.classList.remove('background-brightSun');

          sliderDayNightBGSlide.classList.add('background-easternBlue');
        }

        if (dayOverule === 'yellow') {
          sliderDayNightText.innerHTML = 'dag';
          sliderDayNightBGSlide.classList.remove('background-easternBlue');

          sliderDayNightBGSlide.classList.add('background-brightSun');
        } if (dayOverule === 'blue') {
          sliderDayNightText.innerHTML = 'nacht';
          sliderDayNightBGSlide.classList.remove('background-brightSun');

          sliderDayNightBGSlide.classList.add('background-easternBlue');
        }
        sliderTimeText.innerHTML = sliderTimeSlide;
      },
    },
  });
};

export default snbSliderInit;
